/**
 * @constructor
 */
function TOTPBackupCodesView() {
    var self = this;

    var $content = $(require("html!./totp_backup_codes_view.html"));
    var $codesTable = $content.find("table");
    var $generateButton = $content.find("button");

    $generateButton.on("click", function() {
        self.publishEvent("TOTPSettingsDelegate", "generate-backup-codes");
    });

    // Add click event to each backup code input to select entire code (user-select=all does not work on some browsers)
    $codesTable.find("input").on("click", function() {
        $(this).select();
    });

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "TOTPBackupCodes";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::totp.backupCodes.title"),
            i18n : "common::totp.backupCodes.title"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return true;
    };

    this.setCodes = function(codes) {
        var tableCells = $codesTable.find("td");
        var available = tableCells.length - codes.length;

        tableCells.each(function(index, cell) {
            var usedCode = index < available;

            var $input = $(cell).find("input");
            var $usedLabel = $(cell).find("span");
            $input.toggle(!usedCode);
            $usedLabel.toggle(usedCode);

            if (usedCode) {
                $usedLabel.text($.t("common::totp.backupCodes.alreadyUsed.label"));
            } else {
                $usedLabel.text("");
                var code = codes[index - available];
                var midPoint = code.length / 2;
                $input.val(code.substr(0, midPoint) + " " + code.substr(midPoint));
            }
        });
    };
}

TOTPBackupCodesView.prototype = require("common/AbstractView");

module.exports = TOTPBackupCodesView;


//////////////////
// WEBPACK FOOTER
// ./settings/totp/TOTPBackupCodesView.js
// module id = 94
// module chunks = 0 3